// @flow

import type {Features} from '../../../containers/disputes/types';
import type {_Action, ActionCreator} from '../../types';

import {getDisputeFeatures} from '../../../api/disputes';

const rootAct = '@publisher/disputes/features';

export const SET_DISPUTE_FEATURES = `${rootAct}/set`;

const setDisputeFeatures = (payload): _Action<Features> => ({
  type: SET_DISPUTE_FEATURES,
  payload
});

export const fetchDisputeFeatures = (merchantId: number): ActionCreator => dispatch =>
  getDisputeFeatures(merchantId)
    .then(response => {
      dispatch(setDisputeFeatures(response));
    })
    .catch(() => dispatch(setDisputeFeatures([])));
